export let termsLink = "fkzVKb";
export default {termsLink};